var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXDismissIcon = function SvgXDismissIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    "data-name": "x"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.71 18.71 5.29-5.3 5.29 5.3 1.42-1.42-5.3-5.29 5.3-5.29-1.42-1.42-5.29 5.3-5.29-5.3-1.42 1.42 5.3 5.29-5.3 5.29z"
  })));
};
export { SvgXDismissIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zWGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiCiAgZGF0YS1uYW1lPSJ4IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKPgogIDxwYXRoCiAgICBkPSJNNi43MTAwNCAxOC43MUwxMiAxMy40MUwxNy4yOSAxOC43MUwxOC43MSAxNy4yOUwxMy40MSAxMkwxOC43MSA2LjcxMDA0TDE3LjI5IDUuMjkwMDRMMTIgMTAuNTlMNi43MTAwNCA1LjI5MDA0TDUuMjkwMDQgNi43MTAwNEwxMC41OSAxMkw1LjI5MDA0IDE3LjI5TDYuNzEwMDQgMTguNzFaIgogICAgZmlsbD0iY3VycmVudENvbG9yIgogIC8+Cjwvc3ZnPg==";